import React from "react";
import { Link, NavLink } from "react-router-dom";

const MobileFooter: React.FC = () => {
  return (
    <div className="relative bottom-12 p-4 pb-0 text-darkBlackColor flex flex-col">
      <div className="border-t border-gray-200 flex flex-col">
        <div className="flex flex-wrap justify-center space-between">
          <div className="flex flex-col mt-7 mr-10 text-xs space-y-3">
            <h1 className="font-helveticaBold mb-1">Company</h1>
            <NavLink
              to="/about"
              className={({ isActive }) => (isActive ? "font-bold" : "")}
            >
              About
            </NavLink>
            <NavLink
              to="/advantages"
              className={({ isActive }) => (isActive ? "font-bold" : "")}
            >
              Advantages
            </NavLink>
            <NavLink
              to="/ourVendors"
              className={({ isActive }) => (isActive ? "font-bold" : "")}
            >
              Vendors
            </NavLink>
            <NavLink
              to="/contact-us"
              className={({ isActive }) => (isActive ? "font-bold" : "")}
            >
              Contact Us
            </NavLink>
          </div>
          <div className="flex flex-col mt-7 mr-5 text-xs space-y-3">
            <h1 className="font-helveticaBold mb-1">Data</h1>
            <NavLink
              to="/credentials"
              className={({ isActive }) => (isActive ? "font-bold" : "")}
            >
              Credentials
            </NavLink>
            <NavLink
              to="/terms-of-use"
              className={({ isActive }) => (isActive ? "font-bold" : "")}
            >
              Terms & Conditions
            </NavLink>
            <NavLink
              to="/privacy-policy"
              className={({ isActive }) => (isActive ? "font-bold" : "")}
            >
              Privacy Policy
            </NavLink>
            <NavLink
              to="/imprint-data-protection"
              className={({ isActive }) => (isActive ? "font-bold" : "")}
            >
              Imprint Data Protection
            </NavLink>
          </div>
          <div className="flex flex-col mt-7 text-xs space-y-3">
            <h1 className="font-helveticaBold mb-1">Follow us</h1>
            <p>
              <a href="https://www.facebook.com/afrocart.ca">Facebook</a>
            </p>
            <p>
              <a href="https://www.instagram.com/afrocart.ca">Instagram</a>
            </p>
            <p>
              <a href="https://x.com/afrocart">Twitter</a>
            </p>
          </div>
        </div>

        <a
          href="mailto: admin@afrocart.ca"
          className="mt-7 font-helveticaMedium flex item-center justify-center text-2xl leading-6 text-customGreenColor"
        >
          admin@afrocart.ca
        </a>

        <div className="flex flex-col mt-4">
          {/* <h1 className='font-helveticaBold text-xl'>Join our VIP club</h1>
                    <p className='font-normal text-sm text-customGrayBase'>Get exclusive access to special offers, free giveaways, and once-in-a-lifetime deals.</p>
                    <div className="relative inline-block mt-4">
                        <input
                            type="text"
                            className="p-4 border w-full cursor-not-allowed rounded-md focus:outline-none focus:ring-2 focus:ring-dHuntGreen"
                            placeholder="Type your email here"
                            readOnly
                        />
                        <button
                            disabled={true}
                            className="absolute cursor-not-allowed inset-y-0 right-0 p-4 bg-dHuntGreen text-white rounded-r-md hover:dHuntGreen focus:outline-none focus:ring-2 focus:ring-dHuntGreen"
                        >
                            Subscribe
                        </button>
                    </div> 
                    Might be used later*/}

          {/* <img
            src="./Images/HomepageImages/MobileCards/Payment Card.png"
            alt="different payment methods available"
            className="mt-4"
          /> */}

          <h1 className="font-normal text-sm self-center mt-3 -mb-10">
            © Copyright@{new Date().getFullYear()} Afrocart. All rights reserved
          </h1>
        </div>
      </div>
    </div>
  );
};
export default MobileFooter;
